export default (link) => {
  if (!link || typeof link !== 'string') return false

  return link.split('/').some((path) => path.includes('heliguy.com'))
}
